import { render, staticRenderFns } from "./SignatureList.vue?vue&type=template&id=47a78e18"
import script from "./SignatureList.vue?vue&type=script&lang=js"
export * from "./SignatureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports